
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("leLdu", function(module, exports) {
/* EmojiTitleSelection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $T1bCI = parcelRequire("T1bCI");


var $jxs8y = parcelRequire("jxs8y");

var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $eEA8O = parcelRequire("eEA8O");


var $9ekTs = parcelRequire("9ekTs");


var $bQm3c = parcelRequire("bQm3c");

function $b938a752f9cdcabf$export$fd5a90cff4ec1050(list) {
    return list[Math.floor(Math.random() * list.length)];
}
var $b938a752f9cdcabf$export$b3eb21c9d2ded28b = /*#__PURE__*/ function(EmojiPageHeaderCohort) {
    EmojiPageHeaderCohort["NOT_ENROLLED"] = "not-enrolled";
    EmojiPageHeaderCohort["CONTROL"] = "control";
    EmojiPageHeaderCohort["EMOJI"] = "emoji";
    EmojiPageHeaderCohort["HEADER"] = "header";
    EmojiPageHeaderCohort["EMOJI_AND_HEADER"] = "emoji_and_header";
    return EmojiPageHeaderCohort;
}({});

const $39022daf6a4c1688$export$4e7972dcd38f7091 = [
    {
        emoji_value: '1f91d',
        emoji_title: 'Handshake'
    },
    {
        emoji_value: '1f9e0',
        emoji_title: 'Brain'
    },
    {
        emoji_value: '1f680',
        emoji_title: 'Rocket'
    },
    {
        emoji_value: '1fa84',
        emoji_title: 'Magic Wang'
    },
    {
        emoji_value: '1f4a1',
        emoji_title: 'Bulb'
    },
    {
        emoji_value: '1f9e9',
        emoji_title: 'Jigsaw'
    },
    {
        emoji_value: '2728',
        emoji_title: 'Sparkles'
    },
    {
        emoji_value: '1f4ad',
        emoji_title: 'Thought Balloon'
    },
    {
        emoji_value: '1f64c',
        emoji_title: 'Raising Hands'
    },
    {
        emoji_value: '1f4bb',
        emoji_title: 'Computer'
    }
];
const $39022daf6a4c1688$export$d787f12e5de18134 = [
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1554034483-04fda0d3507b?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/GLf7bAwCdYg/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_1'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1557683316-973673baf926?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/pJadQetzTkI/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_2'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1618397746666-63405ce5d015?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/iFu2HILEng8/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_3'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/pxoZSTdAzeU/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_4'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1533090161767-e6ffed986c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/BlIhVfXbi9s/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_5'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1503551723145-6c040742065b-v2?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/ETRPjvb0KM0/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_6'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1518655048521-f130df041f66?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/VieM9BdZKFo/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_7'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1577017040065-650ee4d43339?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/xREzOtWzDrQ/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_8'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1508841220-87fbee1b4767?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/4umhCRrivis/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_9'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1751315039431-86ad38f1b046?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/FsZoT5CQjm0/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_10'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1750190437388-862aeca97f9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/Ljkx9b71l54/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_11'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/Q1p7bh3SHj8/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_12'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1479030160180-b1860951d696?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/WeYamle9fDM/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_13'
    }
];



var $b3j2Y = parcelRequire("b3j2Y");


var $7PLO8 = parcelRequire("7PLO8");


var $3jwuS = parcelRequire("3jwuS");


var $jlIaF = parcelRequire("jlIaF");


var $99t4P = parcelRequire("99t4P");



var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $5kqgA = parcelRequire("5kqgA");


var $1dhEU = parcelRequire("1dhEU");


var $crLHf = parcelRequire("crLHf");


var $3shHM = parcelRequire("3shHM");


var $brn6e = parcelRequire("brn6e");


var $AV9gd = parcelRequire("AV9gd");


var $8rneB = parcelRequire("8rneB");


var $Qlykt = parcelRequire("Qlykt");


var $5amrO = parcelRequire("5amrO");


var $aV0YS = parcelRequire("aV0YS");


var $ktUCG = parcelRequire("ktUCG");


var $87Z8O = parcelRequire("87Z8O");

/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");





var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");

const $b00dc175a1d9f562$export$451b1c9c9e3f3651 = ({ emojiLoading: emojiLoading, hasSelectedEmoji: hasSelectedEmoji, contentId: contentId, isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const shouldQueryForSpaceIcon = !emojiLoading && !hasSelectedEmoji && Boolean(spaceKey) && isSpaceTypesCreationFlowEnabled && // The feature Company Hub uses a special space type "system" which is
    // mostly hidden from the UI and the user predominantly sees the space
    // homepage / overview presented with feature-specific customizations and
    // referred to as "front cover" or "landing page". Because the space is
    // hidden from the user, the UI concent "space icon" doesn't make sense.
    !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useSpaceIconSpaceIconQuery($spaceKey:String!){space(key:$spaceKey){id icon{path}homepage{id}}}`, {
        variables: {
            spaceKey: spaceKey || ''
        },
        skip: !shouldQueryForSpaceIcon
    });
    const isEditingOverview = data?.space?.homepage?.id === contentId;
    return {
        spaceIconPath: isEditingOverview ? data?.space?.icon?.path : undefined,
        loading: loading
    };
};


/** @graphql cc **/ 


const $511e56712e6d28ff$export$46195502d4626dda = (0, $eSUdr.default)`query ContextualTitleEmojiQuery($pageAri:ID!$pageTitle:String!){confluence_contextualTitleEmoji(pageAri:$pageAri pageTitle:$pageTitle)}`;


/**
 * @generated SignedSource<<afe6813b52f50df62f9b201fab5e0166>>
 * @relayHash fa8d1823edd0954847716726750cb751
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 425fb5abbbccbd28041eb61d9421fb80cb5556cbd7425f00078f5eb05f763d8a
const $086ed18565cd8445$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "ConfluenceMutationApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "ConfluenceCreatePagePropertyPayload",
                    "kind": "LinkedField",
                    "name": "createPageProperty",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "ConfluencePageProperty",
                            "kind": "LinkedField",
                            "name": "pageProperty",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa8d1823edd0954847716726750cb751",
            "id": "425fb5abbbccbd28041eb61d9421fb80cb5556cbd7425f00078f5eb05f763d8a",
            "metadata": {},
            "name": "useEmojiEverSetPropertyMutation",
            "operationKind": "mutation",
            "text": "mutation useEmojiEverSetPropertyMutation($input:ConfluenceCreatePagePropertyInput!){confluence{createPageProperty(input:$input){success,pageProperty{key,value},errors{message}}}}"
        }
    };
}();
$086ed18565cd8445$var$node.hash = "771265924e6d3ef23e44e1c16875a2ba";
var $086ed18565cd8445$export$2e2bcd8739ae039 = $086ed18565cd8445$var$node;



var $32Xjk = parcelRequire("32Xjk");





var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");







const $21d4c90e14666aa3$var$EMOJI_EVER_SET_PROPERTY_KEY = 'emoji-ever-set';
function $21d4c90e14666aa3$export$c30a2ad7de291c21({ pageAri: pageAri, contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, isLivePage: isLivePage, autoPageEmojiCohort: autoPageEmojiCohort }) {
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $32Xjk.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('auto_page_emoji_kill_switch')
    });
    const [createPropertyMutation, { loading: updating }] = (0, $308Wd.useMutationInterop)(/** @schema agg */ (0, $086ed18565cd8445$export$2e2bcd8739ae039), {
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const setEmojiEverSet = (0, $42omo.useCallback)(async (value = true)=>{
        if (!contentId || !pageAri || !(0, $9wGTI.fg)('auto_page_emoji_kill_switch')) return false;
        try {
            const result = await createPropertyMutation({
                variables: {
                    input: {
                        pageId: pageAri,
                        key: $21d4c90e14666aa3$var$EMOJI_EVER_SET_PROPERTY_KEY,
                        value: String(value)
                    }
                }
            });
            const success = result?.data?.confluence?.createPageProperty?.success;
            if (success) {
                refetch();
                if (createAnalyticsEvent && autoPageEmojiCohort && (autoPageEmojiCohort === 'ai' || autoPageEmojiCohort === 'random')) createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'success',
                        actionSubject: 'updateEmojiEverSetProperty',
                        source: 'useEmojiEverSetProperty',
                        attributes: {
                            cohort: autoPageEmojiCohort,
                            contentType: contentType,
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return success || false;
        } catch  {
            if (createAnalyticsEvent && autoPageEmojiCohort && (autoPageEmojiCohort === 'ai' || autoPageEmojiCohort === 'random')) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'errored',
                    actionSubject: 'updateEmojiEverSetProperty',
                    source: 'useEmojiEverSetProperty',
                    attributes: {
                        cohort: autoPageEmojiCohort,
                        contentType: contentType,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            return false;
        }
    }, [
        contentId,
        pageAri,
        createPropertyMutation,
        refetch,
        createAnalyticsEvent,
        contentType,
        isLivePage,
        autoPageEmojiCohort
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data && createAnalyticsEvent && autoPageEmojiCohort && (autoPageEmojiCohort === 'ai' || autoPageEmojiCohort === 'random')) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'success',
                actionSubject: 'emojiEverSetProperty',
                source: 'useEmojiEverSetProperty',
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        data,
        createAnalyticsEvent,
        contentType,
        isLivePage,
        autoPageEmojiCohort
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error && createAnalyticsEvent && autoPageEmojiCohort && (autoPageEmojiCohort === 'ai' || autoPageEmojiCohort === 'random')) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'emojiEverSetProperty',
                source: 'useEmojiEverSetProperty',
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent,
        contentType,
        isLivePage,
        autoPageEmojiCohort
    ]);
    if (!contentId || !pageAri || !(0, $9wGTI.fg)('auto_page_emoji_kill_switch')) // By default, we don't want to set the emoji if we don't know the result so hasEverSetEmoji is true.
    return {
        hasEverSetEmoji: true,
        setEmojiEverSet: ()=>Promise.resolve(false),
        loading: false,
        error: null,
        updating: false
    };
    const currentValue = data?.content?.nodes?.[0]?.properties?.nodes?.find((prop)=>prop?.key === $21d4c90e14666aa3$var$EMOJI_EVER_SET_PROPERTY_KEY)?.value;
    const hasEverSetEmoji = currentValue === 'true';
    return {
        hasEverSetEmoji: hasEverSetEmoji,
        setEmojiEverSet: setEmojiEverSet,
        loading: loading,
        error: error,
        updating: updating
    };
}



var $jX9na = parcelRequire("jX9na");


const $f5191b0954c119ca$var$LiveDocsDefaultIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d9Ygm",
    name: "LiveDocsDefaultIcon",
    loader: async ()=>(await (parcelRequire("dnupa"))).LiveDocsDefaultIcon,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: props.size
        })
});
const $f5191b0954c119ca$export$c6f7e57f9a3b1251 = 20;
const $f5191b0954c119ca$var$EmojiButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1e0c1txw" : "_1e0c18uv",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_ae4v1h6o" : "_ae4v4jg8",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_4cvr1h6o" : "_4cvr4jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$EmojiIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ca0qn7od _u5f3n7od _n3tdn7od _19bvn7od _1e0c1txw _1bah1h6o _19pkn7od",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_p12fgktf" : __cmplp.hasCoverPicture ? "_p12fys9h" : "_p12f1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f5191b0954c119ca$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isTitleCenterAligned ? "_u5f3idpf" : "_u5f3u2gc",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_18u0i2wt" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f5191b0954c119ca$export$33fbbc033604b878 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, shouldHide: shouldHide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkn7od",
            __cmplp.isTitleCenterAligned ? "_2hwxidpf" : "_2hwxutpp",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_19bvidpf" : "_19bv1b66",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_p12fgktf" : __cmplp.hasCoverPicture ? "_p12fys9h" : "_p12f1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.shouldHide ? "_1e0cglyw" : !__cmplp.hasCoverPicture && !__cmplp.isTitleCenterAligned ? "_1e0c1txw" : "_1e0c1kw7",
            __cmplp.shouldHide ? "_y05fidpf" : "_y05fkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$EmojiIconOuterWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$SpaceIconImg = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _1wpz1h6o _1pbyidpf",
            __cmplp.isTitleCenterAligned ? "_19pkze3t" : "_19pk1b66",
            __cmplp.isTitleCenterAligned ? "_2hwxze3t" : "_2hwxu2gc",
            __cmplp.isTitleCenterAligned ? "_otyrpxbi" : "_otyrze3t",
            __cmplp.className
        ])
    });
}); // During SSR inline styles have problems getting calculated so needs to be moved into a styled button component
const $f5191b0954c119ca$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_w1ap1tcg" : __cmplp.hasCoverPicture ? "_w1apys9h" : "_w1ap1wug",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_btpd1tcg" : __cmplp.hasCoverPicture ? "_btpdys9h" : "_btpd1wug",
            __cmplp.isReadOnly ? "_1mr21wug" : "_1mr2tlke",
            __cmplp.className
        ])
    });
});
const $f5191b0954c119ca$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { style: style, ...otherProps } = props; // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...otherProps,
        ref: ref,
        style: {
            ...style
        }
    });
});
const $f5191b0954c119ca$var$i18n = (0, $cgtv4.defineMessages)({
    changeEmoji: {
        id: "emoji-title.change-emoji",
        defaultMessage: "Change emoji"
    },
    spaceIconAlt: {
        id: "emoji-title.space-icon-alt",
        defaultMessage: "space icon"
    },
    liveDocsDefaultIconLabel: {
        id: "emoji-title.live-docs-default-icon-label",
        defaultMessage: "Live doc emoji"
    }
}); // Returns previous emoji ID
function $f5191b0954c119ca$var$usePrevious(value) {
    const emojiRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        emojiRef.current = value;
    }, [
        value
    ]);
    return emojiRef.current;
}
const $f5191b0954c119ca$var$EmojiTitleSelectionComponent = ({ contentId: contentId, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, isTitleDisabled: isTitleDisabled, linkCreation: linkCreation, emojiTitleState: emojiTitleState, isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, isReadOnly: isReadOnly, isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled, contentType: contentType, updateContentTree: updateContentTree, hasInitialEmoji: hasInitialEmoji, onEmojiPickerClose: onEmojiPickerClose, pageTitleContent: pageTitleContent, autoPageEmojiCohort: autoPageEmojiCohort, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty, emojiTitleDiscovered: emojiTitleDiscovered })=>{
    const intl = (0, $8C5kA.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const emojiStatusFieldName = (0, $5amrO.useEmojiStatusFieldName)(contentType);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageAri = (0, $42omo.useMemo)(()=>{
        try {
            return (0, $9ekTs.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: contentId
            }).toString();
        } catch  {
            return null;
        }
    }, [
        cloudId,
        contentId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { hasEverSetEmoji: hasEverSetEmoji, setEmojiEverSet: setEmojiEverSet, loading: emojiEverSetPropertyLoading, error: emojiEverSetPropertyError, updating: emojiEverSetPropertyUpdating } = (0, $21d4c90e14666aa3$export$c30a2ad7de291c21)({
        pageAri: pageAri,
        contentId: contentId,
        createAnalyticsEvent: createAnalyticsEvent,
        contentType: contentType,
        isLivePage: isLivePage,
        autoPageEmojiCohort: autoPageEmojiCohort
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const hasGeneratedEmojiBefore = hasEverSetEmoji || emojiEverSetPropertyError || emojiEverSetPropertyLoading || emojiEverSetPropertyUpdating;
    const { isContextualEmojiEnabled: isContextualEmojiEnabled } = (0, $jX9na.useContextualEmojiUserPreferences)();
    const isWhiteboardEmojiFGEnabled = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    const closeBothEmojiPicker = ()=>{
        emojiTitleState.setOpenFirstEmojiPicker(false);
        emojiTitleState.setOpenSecondEmojiPicker(false);
    };
    const [getContextualEmoji, { data: queryData, error: contextualEmojiError }] = (0, $jxs8y.useLazyQuery)((0, $511e56712e6d28ff$export$46195502d4626dda)); // checks that the title is not default text, has characters, not just whitespace
    const isMeaningfulTitle = (title)=>{
        const trimmedTitle = title.trim();
        return trimmedTitle.length >= 3 && /[a-zA-Z]/.test(trimmedTitle) && !/^\s*$/.test(trimmedTitle);
    }; // optimistically show placeholder prior to querying for emoji data when
    // parent component has determined that there should be an emoji
    const [showOptimisticPlaceholder, setShowOptimisticPlaceholder] = (0, $42omo.useState)(!!hasInitialEmoji); // Track current emoji data for versioning
    const currentEmojiDataRef = (0, $42omo.useRef)(null);
    const isInRandomEmojiCohort = autoPageEmojiCohort && autoPageEmojiCohort === 'random'; // Additional checks to see if the user is eligible to get a random emoji on the content they are on.
    // These checks are: the content is a draft page, draft blogpost or live page, the editor is empty, and there is no title.
    const isEligibleForRandomEmojiExperience = isInRandomEmojiCohort && (isLivePage || isUnpublishedDraft) && isEditorEmpty && !pageTitleContent;
    const contextualEmojiExp = autoPageEmojiCohort && autoPageEmojiCohort === 'ai' && isContextualEmojiEnabled;
    (0, $42omo.useEffect)(()=>{
        if (queryData?.confluence_contextualTitleEmoji !== undefined && contextualEmojiExp) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'success',
                actionSubject: 'contextualEmojiQuery',
                source: 'EmojiTitleSelection',
                attributes: {
                    cohort: 'ai',
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        queryData,
        contextualEmojiExp,
        createAnalyticsEvent,
        contentType,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (contextualEmojiError && contextualEmojiExp) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'contextualEmojiQuery',
                source: 'EmojiTitleSelection',
                attributes: {
                    cohort: 'ai',
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contextualEmojiError,
        contextualEmojiExp,
        createAnalyticsEvent,
        contentType,
        isLivePage
    ]);
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page',
        options: {
            refetchQueries: [
                'getEmojiTitlePropertyQuery'
            ]
        }
    }); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [updateContentPropertyExperimentalMutation] = (0, $1KmJq.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $aV0YS.UpdateContentPropertyMutation), {
        refetchQueries: [
            'getEmojiTitlePropertyQuery'
        ]
    }); // Helper function to convert emoji character to Unicode ID
    const emojiToUnicode = (emoji)=>{
        const codePoint = emoji.codePointAt(0);
        return codePoint?.toString(16) || '';
    };
    const handleAutoEmojiSelection = (0, $42omo.useCallback)(async (autoEmojiId)=>{
        if (autoEmojiId) {
            // converts emoji character to unicode id
            const isEmojiCharacter = !/^[0-9a-f]+$/i.test(autoEmojiId);
            const unicodeId = isEmojiCharacter ? emojiToUnicode(autoEmojiId) : autoEmojiId; // load full emoji data for UI display
            if (!userId) return;
            const loadedEmoji = await (0, $brn6e.getEmojiFromEmojiId)({
                userId: userId,
                cloudId: cloudId,
                emojiId: unicodeId
            });
            if (loadedEmoji) {
                emojiTitleState.setSelectedEmoji(loadedEmoji); // save to backend
                const propertyKey = emojiStatusFieldName === 'emojiTitlePublished' ? 'emoji-title-published' : 'emoji-title-draft';
                const emojiValue = unicodeId.replace(/['"]+/g, ''); // get current version number from previous emoji data and increment it
                const currentVersion = currentEmojiDataRef.current && (0, $8rneB.getVersionNumber)(currentEmojiDataRef.current, emojiStatusFieldName);
                const newVersion = currentVersion ? currentVersion + 1 : 1;
                if ((0, $6mKj3.expValEquals)('migrate_off_experimentalupdatecontentproperty', 'isEnabled', true)) updateContentProperty({
                    propertyKey: propertyKey,
                    propertyValue: emojiValue,
                    hasExistingProperty: currentVersion > 0
                });
                else updateContentPropertyExperimentalMutation({
                    variables: {
                        contentId: contentId,
                        propertyKey: propertyKey,
                        propertyValue: emojiValue,
                        versionNumber: String(newVersion)
                    }
                });
                setEmojiEverSet(true);
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        emojiTitleState,
        cloudId,
        userId,
        updateContentProperty,
        updateContentPropertyExperimentalMutation,
        contentId,
        emojiStatusFieldName
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!emojiTitleDiscovered && !hasGeneratedEmojiBefore && !emojiTitleState.state.selectedEmoji && isEligibleForRandomEmojiExperience) {
            const randomEmojiId = (0, $b938a752f9cdcabf$export$fd5a90cff4ec1050)((0, $39022daf6a4c1688$export$4e7972dcd38f7091)).emoji_value;
            handleAutoEmojiSelection(randomEmojiId);
        }
    }, [
        emojiTitleDiscovered,
        hasGeneratedEmojiBefore,
        emojiTitleState.state.selectedEmoji,
        isEligibleForRandomEmojiExperience,
        handleAutoEmojiSelection
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!hasGeneratedEmojiBefore && queryData?.confluence_contextualTitleEmoji != null && !emojiTitleState.state.selectedEmoji && contextualEmojiExp) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'contextualEmoji',
                    source: 'EmojiTitleSelection',
                    attributes: {
                        cohort: 'ai',
                        contentType: contentType,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            let contextualEmojiId = queryData?.confluence_contextualTitleEmoji; // if contextual emoji is empty, default to random emoji
            if (contextualEmojiId === '') contextualEmojiId = (0, $b938a752f9cdcabf$export$fd5a90cff4ec1050)((0, $39022daf6a4c1688$export$4e7972dcd38f7091)).emoji_value;
            handleAutoEmojiSelection(contextualEmojiId);
        }
    }, [
        queryData?.confluence_contextualTitleEmoji,
        contextualEmojiExp,
        hasGeneratedEmojiBefore,
        emojiTitleState.state.selectedEmoji,
        handleAutoEmojiSelection,
        createAnalyticsEvent,
        contentType,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        //analytics event for auto emoji exp cohort assignment
        if (autoPageEmojiCohort && (autoPageEmojiCohort === 'random' || autoPageEmojiCohort === 'ai' || autoPageEmojiCohort === 'control')) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'assigned',
                actionSubject: 'autoEmojiExperiment',
                source: 'EmojiTitleSelection',
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        autoPageEmojiCohort,
        contentType,
        isLivePage,
        createAnalyticsEvent
    ]);
    const isUndefinedLink = isTitleDisabled && linkCreation;
    const shouldQueryEmoji = !isTitleDisabled || isUndefinedLink;
    const { data: data, error: error, refetch: refetchEmoji, loading: loading } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $87Z8O.getEmojiTitleProperty), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        fetchPolicy: 'cache-and-network',
        skip: !shouldQueryEmoji
    });
    const emojiId = (data && (0, $8rneB.getEmojiId)(data, emojiStatusFieldName)) ?? ''; // Update ref when data changes
    (0, $42omo.useEffect)(()=>{
        currentEmojiDataRef.current = data;
    }, [
        data
    ]);
    const updateLivePagesDefaultIcon = (0, $42omo.useCallback)(()=>{
        if (isLivePage && data) {
            const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(data);
            emojiTitleState.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji);
        }
    }, [
        data,
        isLivePage,
        emojiTitleState
    ]); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const hasEmojiFromStateContainer = !!emojiTitleState.state.selectedEmoji; // When gate is enabled, rely on state container since it has the most up to date info
    const hasEmoji = (0, $9wGTI.fg)('confluence_populate_emoji_title_container_ssr') ? hasEmojiFromStateContainer : !!(data && (0, $8rneB.getHasEmoji)(data, emojiStatusFieldName)); // Contextual emoji API (only triggered on blur)
    (0, $42omo.useEffect)(()=>{
        // Only make contextual emoji API call if there's no existing emoji (user hasn't manually set one)
        // and the user hasn't manually removed an emoji
        // and the user has enabled contextual emoji in their preferences
        if (pageTitleContent && isMeaningfulTitle(pageTitleContent) && pageAri && !hasEmoji && !hasGeneratedEmojiBefore && contextualEmojiExp) getContextualEmoji({
            variables: {
                pageAri: pageAri,
                pageTitle: pageTitleContent
            }
        });
    }, [
        pageTitleContent,
        contentId,
        hasEmoji,
        getContextualEmoji,
        pageAri,
        hasGeneratedEmojiBefore,
        contextualEmojiExp
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasEmoji && emojiId.length > 0) (0, $brn6e.getEmojiFromEmojiId)({
            userId: userId,
            cloudId: cloudId,
            emojiId: emojiId
        }).then((emoji)=>{
            emoji && emojiTitleState.setSelectedEmoji(emoji);
            emojiTitleState.setLoadingEmoji(false);
        });
        else if (!loading && emojiTitleState.state.isLoading) emojiTitleState.setLoadingEmoji(false);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasEmoji,
        emojiId,
        loading
    ]); // Previous Emoji ID
    const previousEmojiId = $f5191b0954c119ca$var$usePrevious(emojiId);
    const onEmojiIdChange = previousEmojiId != emojiId; // Used to update the content tree emoji when the emoji is changed from the header
    if (onEmojiIdChange && updateContentTree) updateContentTree();
    const { spaceIconPath: spaceIconPath } = (0, $b00dc175a1d9f562$export$451b1c9c9e3f3651)({
        emojiLoading: loading,
        hasSelectedEmoji: Boolean(emojiTitleState.state.selectedEmoji),
        contentId: contentId,
        isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled
    }); // Live docs default icon and optimistic placeholder
    (0, $42omo.useEffect)(()=>{
        const setEmojiStateAndUpdateOptimisticPlaceholder = async ()=>{
            // When default emoji is enabled, we need to wait until after the emojiTitleState is set
            // to stop rendering the optimistic placeholder in order to prevent flashing
            updateLivePagesDefaultIcon();
            if (data) setShowOptimisticPlaceholder(false);
        };
        setEmojiStateAndUpdateOptimisticPlaceholder();
    }, [
        data,
        updateLivePagesDefaultIcon
    ]); // clean up emojiTitleState on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            emojiTitleState.setSelectedEmoji(null);
            emojiTitleState.setHasLiveDocsDefaultEmoji(false);
        };
    }, [
        emojiTitleState
    ]);
    const getEmojiSize = ()=>isWhiteboardEmojiFGEnabled ? $f5191b0954c119ca$export$c6f7e57f9a3b1251 : hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM); // double checks against hasEmoji to make sure that the selectedEmoji is for this contentId
    // checks to see if emoji is being queried and if the selectedEmoji is currently updating
    const shouldRenderEmojiBase = Boolean(hasEmoji && !emojiTitleState.state.isUpdatingEmoji && emojiTitleState.state.selectedEmoji); // Don't rely on query loading state if gate is on since we want to rely on container only.
    const shouldRenderEmoji = (0, $9wGTI.fg)('confluence_populate_emoji_title_container_ssr') ? shouldRenderEmojiBase : shouldRenderEmojiBase && !loading;
    const hasDefaultLiveEmoji = emojiTitleState.state.hasLiveDocsDefaultEmoji && !emojiTitleState.state.isRemovingEmoji && !emojiTitleState.state.isUpdatingEmoji;
    const shouldRenderDefaultLiveEmoji = hasDefaultLiveEmoji && !hasEmoji;
    const shouldHidePlaceholderBase = !hasEmoji && !hasDefaultLiveEmoji && !showOptimisticPlaceholder;
    const shouldHidePlaceholder = (0, $9wGTI.fg)('confluence_populate_emoji_title_container_ssr') ? shouldHidePlaceholderBase : shouldHidePlaceholderBase && !hasEmojiFromStateContainer; // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (shouldRenderEmoji || shouldRenderDefaultLiveEmoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$export$e31a6cc0a4c97f0e, {
        "data-testid": isTitleCenterAligned ? 'emoji-wrapper-centered' : 'emoji-wrapper',
        isTitleCenterAligned: isTitleCenterAligned,
        isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        autoFocus: false,
        isOpen: emojiTitleState.state.openFirstEmojiPicker,
        onClose: ()=>{},
        popupComponent: $f5191b0954c119ca$var$PopupComponent,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AV9gd.EmojiPickerLoader), {
                contentId: contentId,
                onUpdateStartEmoji: onUpdateStartEmoji,
                emojiTitleState: emojiTitleState,
                onEmojiUpdated: refetchEmoji,
                onUpdateEndEmoji: onUpdateEndEmoji,
                updateContentPropertyExperimentalMutation: updateContentPropertyExperimentalMutation,
                updateContentProperty: updateContentProperty,
                closeBothEmojiPicker: ()=>{
                    closeBothEmojiPicker();
                    onEmojiPickerClose?.();
                },
                componentName: "EmojiTitleSelection",
                contentType: contentType,
                autoPageEmojiCohort: autoPageEmojiCohort
            }),
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$EmojiButtonWrapper, {
                isTitleCenterAligned: isTitleCenterAligned,
                hasCoverPicture: hasCoverPicture,
                isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$StyledButton, {
                ...triggerProps,
                appearance: "subtle",
                testId: "emoji-button",
                shouldFitContainer: true,
                hasCoverPicture: hasCoverPicture,
                isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled,
                isReadOnly: isReadOnly,
                isDisabled: isReadOnly || isUndefinedLink,
                onClick: ()=>{
                    emojiTitleState.setOpenFirstEmojiPicker(!emojiTitleState.state.openFirstEmojiPicker);
                    emojiTitleState.setOpenSecondEmojiPicker(false);
                    if (isInRandomEmojiCohort && !emojiTitleDiscovered) {
                        setOnboardingState({
                            key: (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED,
                            value: 'true'
                        });
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                action: 'completed',
                                actionSubject: 'emojiTitleDiscoveredOnboarding',
                                source: 'EmojiTitleSelection',
                                attributes: {
                                    cohort: 'random',
                                    contentType: contentType,
                                    isLivePage: isLivePage
                                }
                            }
                        }).fire();
                    }
                    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
                        eventType: 'sendUIEvent',
                        element: 'button',
                        action: 'clicked',
                        actionSubject: 'editEmojiButton',
                        actionSubjectId: 'emojiIcon',
                        attributes: {
                            cohort: autoPageEmojiCohort,
                            contentType: contentType,
                            isLivePage: isLivePage
                        }
                    });
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$EmojiIconOuterWrapper // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                , {
                    className: "emoji-icon",
                    "data-testid": "emoji-icon",
                    hasCoverPicture: !!hasCoverPicture,
                    isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: intl.formatMessage($f5191b0954c119ca$var$i18n.changeEmoji),
                    position: hasCoverPicture ? 'top' : 'left'
                }, shouldRenderDefaultLiveEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$LiveDocsDefaultIcon, {
                    label: intl.formatMessage($f5191b0954c119ca$var$i18n.liveDocsDefaultIconLabel),
                    size: getEmojiSize(),
                    testId: "live-docs-default-title-icon"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$EmojiIconWrapper, {
                    hasCoverPicture: !!hasCoverPicture,
                    isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1dhEU.EmojiComponent), {
                    emoji: emojiTitleState.state.selectedEmoji,
                    height: getEmojiSize(),
                    context: "editor",
                    renderResourcedEmoji: true,
                    hasCoverPicture: hasCoverPicture,
                    isPageTitleComponent: true
                }))))
            }))
    }));
    else if (!isWhiteboardEmojiFGEnabled) {
        if (spaceIconPath) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$SpaceIconImg, {
            src: `${(0, $jlIaF.CONTEXT_PATH)}${spaceIconPath}`,
            height: getEmojiSize(),
            width: getEmojiSize(),
            isTitleCenterAligned: isTitleCenterAligned,
            alt: intl.formatMessage($f5191b0954c119ca$var$i18n.spaceIconAlt)
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$export$33fbbc033604b878, {
            "data-testid": "emoji-placeholder",
            shouldHide: shouldHidePlaceholder,
            "aria-hidden": shouldHidePlaceholder,
            hasCoverPicture: hasCoverPicture,
            isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled,
            isTitleCenterAligned: isTitleCenterAligned
        }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: getEmojiSize(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "emoji-placeholder"
        }));
    }
};
const $f5191b0954c119ca$export$2626335f65c6c2ab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer)
        ]
    }, (emojiTitleState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5191b0954c119ca$var$EmojiTitleSelectionComponent, {
            "data-testid": "emoji-title-selection",
            ...props,
            emojiTitleState: emojiTitleState
        }));
$f5191b0954c119ca$export$2626335f65c6c2ab.displayName = 'EmojiTitleSelection';
module.exports["EMOJI_SIZE_WHITEBOARD"] = $f5191b0954c119ca$export$c6f7e57f9a3b1251;
module.exports["EmojiWrapper"] = $f5191b0954c119ca$export$e31a6cc0a4c97f0e;
module.exports["EmojiPlaceholderWrapper"] = $f5191b0954c119ca$export$33fbbc033604b878;
module.exports["EmojiTitleSelection"] = $f5191b0954c119ca$export$2626335f65c6c2ab;

});

parcelRegister("9ekTs", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $6b85a0e0b8f4dc4d$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $6b85a0e0b8f4dc4d$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("AV9gd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cb0f340ec70ce939$export$ece7683bd8712e82 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "q1NFz",
    name: "EmojiPickerLoader",
    loader: async ()=>(await (parcelRequire("3Ak0w"))).EmojiPicker
});
module.exports["EmojiPickerLoader"] = $cb0f340ec70ce939$export$ece7683bd8712e82;

});

parcelRegister("3Ak0w", function(module, exports) {

let $29c440f486833778$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29c440f486833778$var$load("6wr18"),
    $29c440f486833778$var$load("ffEVr"),
    $29c440f486833778$var$load("Wowvf"),
    $29c440f486833778$var$load("XgRtr")
]).then(()=>parcelRequire('aQXpZ'));

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("aV0YS", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $72c9da4766702cc1$export$b11576441b505b0d = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`mutation UpdateContentPropertyMutation($contentId:String!$propertyKey:String!$propertyValue:String$versionNumber:String$isDelete:Boolean)@experimental{experimentalUpdateContentProperty(contentId:$contentId propertyKey:$propertyKey propertyValue:$propertyValue versionNumber:$versionNumber isDelete:$isDelete){success id key value}}`;
module.exports["UpdateContentPropertyMutation"] = $72c9da4766702cc1$export$b11576441b505b0d;

});

parcelRegister("32Xjk", function(module, exports) {
/**
 * @generated SignedSource<<a9e022e28ab25d508f71b663053f309c>>
 * @relayHash 3d166b53e496ae6a12171538cb6c6ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce
const $6ea889d48284c196$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-ever-set"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-ever-set\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3d166b53e496ae6a12171538cb6c6ca8",
            "id": "47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce",
            "metadata": {},
            "name": "useEmojiEverSetPropertyQuery",
            "operationKind": "query",
            "text": "query useEmojiEverSetPropertyQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}}}"
        }
    };
}();
$6ea889d48284c196$var$node.hash = "7922225ac99254e0526a345863d19578";
var $6ea889d48284c196$export$2e2bcd8739ae039 = $6ea889d48284c196$var$node;
module.exports["default"] = $6ea889d48284c196$export$2e2bcd8739ae039;

});

parcelRegister("jX9na", function(module, exports) {

var $9fFLO = parcelRequire("9fFLO");


var $40EoN = parcelRequire("40EoN");


var $4hQsE = parcelRequire("4hQsE");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");

const $26f2a6a4fa0ce40e$var$UserPreferencesFragment = (0, $4hQsE.default);
const $26f2a6a4fa0ce40e$export$d1c41bd7f3ee286a = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, isLivePage: isLivePage } = options || {};
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $40EoN.default), {
        fetchPolicy: 'cache-and-network'
    });
    const [updateContextualEmojiOptOutServer] = (0, $308Wd.useMutationInterop)((0, $9fFLO.default));
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: $26f2a6a4fa0ce40e$var$UserPreferencesFragment
    });
    const isContextualEmojiEnabled = !data?.userPreferences?.contextualEmojiOptOut;
    (0, $42omo.useEffect)(()=>{
        if (data?.userPreferences && createAnalyticsEvent) {
            const toggledOn = !data.userPreferences.contextualEmojiOptOut;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'success',
                    actionSubject: 'contextualEmojiUserPreference',
                    source: 'useContextualEmojiUserPreferences',
                    attributes: {
                        cohort: 'ai',
                        contentType: contentType,
                        isLivePage: isLivePage,
                        toggledOn: toggledOn
                    }
                }
            }).fire();
        }
    }, [
        data,
        createAnalyticsEvent,
        contentType,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error && createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'contextualEmojiUserPreference',
                source: 'useContextualEmojiUserPreferences',
                attributes: {
                    cohort: 'ai',
                    contentType: contentType,
                    isLivePage: isLivePage,
                    toggledOn: false
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent,
        contentType,
        isLivePage
    ]);
    const updateContextualEmojiOptOut = (0, $42omo.useCallback)(async (newContextualEmojiOptOut)=>{
        writeFragmentInterop({
            fragmentId: '$ROOT_QUERY.userPreferences',
            data: {
                contextualEmojiOptOut: newContextualEmojiOptOut,
                __typename: 'UserPreferences'
            }
        });
        try {
            await updateContextualEmojiOptOutServer({
                variables: {
                    contextualEmojiOptOut: newContextualEmojiOptOut
                }
            });
            if (createAnalyticsEvent) {
                const toggledOn = !newContextualEmojiOptOut;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'success',
                        actionSubject: 'updateContextualEmojiUserPreference',
                        source: 'useContextualEmojiUserPreferences',
                        attributes: {
                            cohort: 'ai',
                            contentType: contentType,
                            isLivePage: isLivePage,
                            toggledOn: toggledOn
                        }
                    }
                }).fire();
            }
        } catch  {
            writeFragmentInterop({
                fragmentId: '$ROOT_QUERY.userPreferences',
                data: {
                    contextualEmojiOptOut: !newContextualEmojiOptOut,
                    __typename: 'UserPreferences'
                }
            });
            if (createAnalyticsEvent) {
                const toggledOn = !newContextualEmojiOptOut;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'errored',
                        actionSubject: 'updateContextualEmojiUserPreference',
                        source: 'useContextualEmojiUserPreferences',
                        attributes: {
                            cohort: 'ai',
                            contentType: contentType,
                            isLivePage: isLivePage,
                            toggledOn: toggledOn
                        }
                    }
                }).fire();
            }
        }
    }, [
        updateContextualEmojiOptOutServer,
        writeFragmentInterop,
        createAnalyticsEvent,
        contentType,
        isLivePage
    ]);
    return {
        isContextualEmojiEnabled: isContextualEmojiEnabled,
        updateContextualEmojiOptOut: updateContextualEmojiOptOut
    };
};
module.exports["useContextualEmojiUserPreferences"] = $26f2a6a4fa0ce40e$export$d1c41bd7f3ee286a;

});

parcelRegister("9fFLO", function(module, exports) {
/**
 * @generated SignedSource<<fa35ae5073a093934cc8bcd48157fe57>>
 * @relayHash 3cb7419e83ef24d2a43af6010f8ec711
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6c892f61b3534b142463458eb41054d4a2186bf40bb585923c90e681fb010ce6
const $5bcc8f7ea5b0f951$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextualEmojiOptOut"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contextualEmojiOptOut",
                            "variableName": "contextualEmojiOptOut"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contextualEmojiOptOut"
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextualEmojiUserPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextualEmojiUserPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3cb7419e83ef24d2a43af6010f8ec711",
            "id": "6c892f61b3534b142463458eb41054d4a2186bf40bb585923c90e681fb010ce6",
            "metadata": {},
            "name": "useContextualEmojiUserPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation useContextualEmojiUserPreferencesMutation($contextualEmojiOptOut:Boolean!){updateUserPreferences(userPreferences:{contextualEmojiOptOut:$contextualEmojiOptOut}){contextualEmojiOptOut,__typename}}"
        }
    };
}();
$5bcc8f7ea5b0f951$var$node.hash = "3463b6db37ef39ac20520559ae206c44";
var $5bcc8f7ea5b0f951$export$2e2bcd8739ae039 = $5bcc8f7ea5b0f951$var$node;
module.exports["default"] = $5bcc8f7ea5b0f951$export$2e2bcd8739ae039;

});

parcelRegister("40EoN", function(module, exports) {
/**
 * @generated SignedSource<<2449ec8dba37779e1c5e9e36583e2bbb>>
 * @relayHash d1beaa948706042f4c92ffe38dba012b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a4619880e3c3efd50ad338b8a09ff2e30f504ebe1b7ae16fbc6c51deabebd4
const $c368d4b146351ca4$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contextualEmojiOptOut"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useContextualEmojiUserPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useContextualEmojiUserPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d1beaa948706042f4c92ffe38dba012b",
            "id": "c9a4619880e3c3efd50ad338b8a09ff2e30f504ebe1b7ae16fbc6c51deabebd4",
            "metadata": {},
            "name": "useContextualEmojiUserPreferencesQuery",
            "operationKind": "query",
            "text": "query useContextualEmojiUserPreferencesQuery{userPreferences{contextualEmojiOptOut}}"
        }
    };
}();
$c368d4b146351ca4$var$node.hash = "bc9a4c9849d6d778b5ea743a2a5c52ab";
var $c368d4b146351ca4$export$2e2bcd8739ae039 = $c368d4b146351ca4$var$node;
module.exports["default"] = $c368d4b146351ca4$export$2e2bcd8739ae039;

});

parcelRegister("4hQsE", function(module, exports) {
/**
 * @generated SignedSource<<3b8bfce76673921c222ddcef4f7d13f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9bd80fe41cb6683$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContextualEmojiUserPreferencesFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "contextualEmojiOptOut"
        }
    ],
    "type": "UserPreferences"
};
$d9bd80fe41cb6683$var$node.hash = "9fb2a4172ed2114c289df4aae3f26325";
var $d9bd80fe41cb6683$export$2e2bcd8739ae039 = $d9bd80fe41cb6683$var$node;
module.exports["default"] = $d9bd80fe41cb6683$export$2e2bcd8739ae039;

});

parcelRegister("dnupa", function(module, exports) {

let $9bd5021f76ffc010$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bd5021f76ffc010$var$load("hUvv7").then(()=>parcelRequire('daJSk'));

});

parcelRegister("dv2RR", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $9d40651b93ec8285$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $9d40651b93ec8285$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("hLgiF", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $cee378513c934e92$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $cee378513c934e92$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});


//# sourceMappingURL=EmojiTitleSelection.8ea6e599.js.map
